import React from "react";
import Typed from "react-typed";

export default function Hero() {
  return (
    <>
      <section
        className="hero bg-cover bg-center mt-5"
        id="hero"
        style={{
          background:
            "url(https://res.cloudinary.com/developerbiodun/image/upload/v1581309837/bg_rbkshw.png)"
        }}
      >
        <div className="container py-5 my-5 index-forward">
          <div className="row">
            <div className="col-md-8 text-white">
              <h2 className="h4 text-primary font-weight-normal mb-0">
                Hi, I am
              </h2>
              <h1 className="text-uppercase text-xl mb-0">
                ADEBAYO{" "}
                <span
                  className="text-primary"
                  style={{ color: "#f7be68 ! important" }}
                >
                  ABIODUN
                </span>
              </h1>
              <h2 className="h4 font-weight-normal mb-5">
                Fullstack Web Developer
              </h2>

              <br />
              <h3 style={{ color: "#f7be68" }}>
                Being {"  "}
                <strong>
                  <Typed
                    strings={[
                      " PASSIONATE   🚀",
                      " CURIOUS  🤔",
                      " COMMITTED  ✌️ "
                    ]}
                    typeSpeed={100}
                    loop
                  />
                </strong>
              </h3>
              {/* <p className="text-shadow">
                A seasoned Web Based Developer with over 3years of wealth of
                experiences in Inforamtion Technology. I’m hard working, super
                curious, passionate, committed, and also a fast learner!
              </p> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
